import { request } from "hooks/useOkoApi/useOkoApi";

// Questions are paged 10 at a time: the carousel loads the first 10 up front and
// only fetches the next page once the educator reaches the end of the loaded set.
// The endpoint clamps limit to 1..50; 10 keeps each round-trip small.
export const CONSENSUS_PAGE_SIZE = 10;

// Fetch one page of consensus questions for a standard prefix. Returns the page
// envelope { total, limit, offset, questions } where `total` is the true count
// matching the filters (MC + OR), so a carousel can show "N of total" up front
// and page through the whole stream via offset = loadedCount.
//
// `has_explanations`/`fetch_inactive` default to false on the endpoint — the
// opposite of what these previews want — so they are always sent explicitly.
export const fetchConsensusQuestionsPage = async ({
  prefix,
  offset = 0,
  limit = CONSENSUS_PAGE_SIZE,
  hasExplanations = true,
  fetchInactive = false,
} = {}) => {
  const params = new URLSearchParams({
    fetch_inactive: String(fetchInactive),
    has_explanations: String(hasExplanations),
    limit: String(limit),
    offset: String(offset),
  });
  if (prefix) {
    params.set("standard_prefix", prefix);
  }

  const data = await request(`questions/fetch/consensus/page?${params.toString()}`, {
    method: "GET",
  });

  return {
    total: Number(data?.total) || 0,
    limit: Number(data?.limit) || limit,
    offset: Number(data?.offset) || offset,
    questions: Array.isArray(data?.questions) ? data.questions : [],
  };
};
